export function getWellListFromTextArea(wellList: Maybe<string>): string[] {
  return (wellList ?? "")
    .split("\n")
    .map((item) => item.trim())
    .filter(Boolean);
}
